define('restaurants',[
  'jquery', 'views/search-form', 'underscore', 'backbone', 'classes/map', 'classes/paginator', 'model-collections/restaurant', 'views/pagination', 'views/search-results', 'common', 'cookie', 'scrollto'
], function($, SearchFormView, _, Backbone, Map, Paginator, Restaurant, PaginatorView, SearchResultsView) {
  return function() {
    $(document).ready(function() {
      var is_mobile_site = $.isMobileSite(),
          $se_el = is_mobile_site ?
            $('#sf-modal') :
            $('#se-filter');
      new SearchFormView({el: $se_el, mobile: is_mobile_site});

      var map,
          centre,
          restaurants_map = new Restaurant.Collection(),
          restaurants_reg = new Restaurant.Collection(),
          restaurants_api = [],
          search_results_view = new SearchResultsView({collection: restaurants_reg, el: $('#se-restaurants')});

      var paginator = new Paginator(paginator_options);
      var pagination_view = new PaginatorView({paginator: paginator, el: '#se-pagination'});

      $('#order_by').change(function() {
        var val = $(this).val(),
            params = {path: '/restaurants'};
        if (val == 1) { // if it's the default, just remove it
          $.removeCookie(order_by_cookie, params);
        }
        else {
          $.cookie(order_by_cookie, val, params);
        }
        $(this).parents('form:first').submit();
      });

      if (is_mobile_site) {
        $('#se-map').height(($(window).height() - 130) + 'px');
        window.addEventListener('resize', function() {
          $('#se-map').height(($(window).height() - 130) + 'px');
        });
      }
      else {
        var min_map_height = 500, min_body_height = $(window).height() - 260;
        var map_height = min_body_height - 195;
        if (map_height < min_map_height) {
          map_height = min_map_height;
        }
        $('#se-map').height((map_height) + 'px');
      }

      var Router = Backbone.Router.extend({

        initialize: function () {
          this.initial_load = false; // not sure if this is needed

          this.route(/^restaurants\/([a-z0-9'-]+)\-(\d+)$/, 'search'); // /ranelagh-265
          this.route(/^restaurants\/([a-z0-9'-]+)\-(\d+)\?.*page=(\d+).*$/, 'search'); // /ranelagh-265?page=2
          this.route(/^restaurants\/([a-z0-9'-]+)\-(\d+)\?((?!page=).*)$/, 'search'); // /ranelagh-265?a=1

          this.route(/^restaurants\/([a-z0-9'-]+)\-(\d+)\/([a-z-]+)$/, 'searchWithType'); // /ranelagh-265/modern
          this.route(/^restaurants\/([a-z0-9'-]+)\-(\d+)\/([a-z-]+)\?.*page=(\d+).*$/, 'searchWithType'); // /ranelagh-265/modern?page=2
          this.route(/^restaurants\/([a-z0-9'-]+)\-(\d+)\/([a-z-]+)\?((?!page=).*)$/, 'searchWithType'); // /ranelagh-265/modern?a=1

          this.route(/^restaurants\/map$/, 'searchMap'); // /map

          this.route(/^restaurants\/near-me\/([+-]?[0-9]{1,2}[.]?[0-9]+),([+-]?[0-9]{1,2}[.]?[0-9]+)\?.*page=(\d+).*$/, 'searchNear'); // /near-me/54.3,-6.2?page=2
          this.route(/^restaurants\/near-me\/([a-z-]+)\/([+-]?[0-9]{1,2}[.]?[0-9]+),([+-]?[0-9]{1,2}[.]?[0-9]+)\?.*page=(\d+).*$/, 'searchNearWithType'); // /near-me/modern/54.3,-6.2?page=2

          this.route(/^restaurants\/near-me\/([+-]?[0-9]{1,2}[.]?[0-9]+),([+-]?[0-9]{1,2}[.]?[0-9]+)$/, 'searchNear'); // /near-me/54.3,-6.2
          this.route(/^restaurants\/near-me\/([+-]?[0-9]{1,2}[.]?[0-9]+),([+-]?[0-9]{1,2}[.]?[0-9]+)\?((?!page=).*)$/, 'searchNear'); // /near-me/54.3,-6.2?a=1
          this.route(/^restaurants\/near-me\/([a-z-]+)\/([+-]?[0-9]{1,2}[.]?[0-9]+),([+-]?[0-9]{1,2}[.]?[0-9]+)$/, 'searchNearWithType'); // /near-me/modern/54.3,-6.2
          this.route(/^restaurants\/near-me\/([a-z-]+)\/([+-]?[0-9]{1,2}[.]?[0-9]+),([+-]?[0-9]{1,2}[.]?[0-9]+)\?((?!page=).*)$/, 'searchNearWithType'); // /near-me/modern/54.3,-6.2?a=1

          Backbone.history.start({pushState: true});
          var this_ = this;
          $(document).on('click', 'a.route', function (e) {
            e.preventDefault();
            this_.navigate($(this).attr('href'), {trigger: true});
          });
        },

        search: function(slug, location_id, page) {

          if (!this.initial_load) {
            this.initial_load = true;
            return;
          }

          this.toggleTabState();
          $('.se-list').show();
          $('#se-map').hide();

          // page can be set to the entire query string, the way the regexes above work
          if (typeof page != 'undefined') {
            var page = parseInt(page) || 1;
          }
          else {
            var page = 1;
          }

          paginator.setPage(page);
          var $se_loading = $('#se-loading');
          $se_loading.show();
          var offset = $.isMobileSite() ? -100 : -30;
          $(document).scrollTo('#se-displaying', 500, {offset: offset});
          if (typeof restaurants_api[page] == 'undefined') {
            restaurants_reg.fetch({
              data: {
                page: page
              },
              success: function(restaurants_collection, restaurants_json) {
                restaurants_api[page] = restaurants_json;
                $se_loading.hide();
              }
            });
          }
          else {
            restaurants_reg.set(restaurants_api[page]);
            $se_loading.hide();
          }
          pagination_view.render(paginator);
        },

        searchWithType: function(slug, type, location_id, page) {
          this.search(slug, location_id, page)  ;
        },

        searchNear: function(latitude, longitude, page) {
          this.search(null, null, page);
        },

        searchNearWithType: function(type, latitude, longitude, page) {
          return this.search(null, null, page);
        },

        searchMap: function() {
          this.toggleTabState(true);
          $('.se-list').hide();
          $('#se-map').show();
          if (!map) {
            // first time we show the map, make sure all restaurants in previous page are visible
            if (typeof restaurants_api[paginator.getPage()] !== 'undefined') {
              var bounds = calc_map_bounds(restaurants_api[paginator.getPage()]);
            }
            else {
              // when we load the page, restaurants_api is empty, so get the bounds from the server
              var bounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(map_bounds['sw'][0], map_bounds['sw'][1]),
                new google.maps.LatLng(map_bounds['ne'][0], map_bounds['ne'][1])
              );
            }
            map = new Map('se-map', restaurants_map, bounds);
            add_near_me_marker(map);
          }
        },

        toggleTabState: function(is_map) {
          var is_map = is_map || false,
              $this = is_map ? $('#se-map-view') : $('#se-list-view'),
              $parent = $this.parent();
          $parent.siblings('.active').removeClass('active');
          $parent.addClass('active');

          var se_list_url = 'javascript:' +
            (is_map ? 'history.back()' : 'void(0)');
          $('#se-list-view').attr('href', se_list_url);
        }

      });

      new Router;

    });

    function calculate_zoom(div) {
      var GLOBE_WIDTH = 256; // a constant in Google's map projection
      var west = map_coords.sw[1];
      var east = map_coords.ne[1];
      var angle = east - west;
      if (angle < 0) {
        angle += 360;
      }
      var zoom = Math.round(Math.log($('#' + div).width() * 360 / angle / GLOBE_WIDTH) / Math.LN2);
      return zoom;

    }

    function add_near_me_marker(map) {
      if (window.location.pathname.substr(0, 21) === '/restaurants/near-me/') {
        new google.maps.Marker({
          position: map.getCenter(),
          map: map
        });
      }
    }

    /*
      Cycle through array of restaurant to find the ones at the most extreme sw and ne positions.
    */
    function calc_map_bounds(restaurants) {
      var lats, lons, sw, ne;

      lats = _.map(restaurants, function(r) { return parseFloat(r.latitude)});
      lons = _.map(restaurants, function(r) { return parseFloat(r.longitude)});

      sw = new google.maps.LatLng(_.min(lats), _.min(lons));
      ne = new google.maps.LatLng(_.max(lats), _.max(lons));

      return new google.maps.LatLngBounds(sw, ne);
    }
  }

});
